<template>
  <div>
    <Card>
      <span slot="title">员工管理</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getUsersList)" class="fr">刷新</el-button>
      <div slot="content" class="wrap">
        <!-- 条件查询 -->
        <div class="search">
          <el-form :inline="true" :model="searchForm">
            <el-form-item label="姓名">
              <el-input v-model="searchForm.nickName" placeholder="请输入员工姓名" />
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="searchForm.phonenumber" placeholder="请输入员工手机号" />
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.status" filterable default-first-option placeholder="请选择员工状态">
                <el-option
                  v-for="item in [{ label: '全部', value: null }, { label: '在职', value: '0' }, { label: '离职', value: '1' }]"
                  :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="$refresh(getUsersList, true)">查询</el-button>
              <el-button icon="el-icon-refresh"
                @click="$reset(getUsersList, { nickName: null, status: null })">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 操作按钮 -->
        <div class="button">
          <el-button icon="el-icon-plus" type="primary" @click="addUser">新增员工</el-button>
          <!-- <el-button icon="el-icon-delete" type="danger" @click="deleteUserList">批量删除</el-button> -->
        </div>
        <!-- 员工列表 -->
        <el-table v-loading="loading" :data="userList" ref="multipleTable" :max-height="tableHeight"
          @selection-change="val => $handleSelectionChange(val, true)" border>
          <!-- <el-table-column type="selection" width="50"> </el-table-column> -->
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column prop="nickName" label="姓名" min-width="100" />
          <el-table-column prop="sex" label="性别">
            <template slot-scope="scope">
              {{ scope.row.sex == '0' ? '男' : '女' }}
            </template>
          </el-table-column>
          <el-table-column prop="phonenumber" label="电话" min-width="120" />
          <el-table-column prop="typeStr" label="类型" />
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              {{ scope.row.status == '0' ? '在职' : '离职' }}
            </template>
          </el-table-column>
          <el-table-column prop="createBy" label="操作员" min-width="100" />
          <el-table-column prop="createTime" label="创建时间" min-width="160" />
          <el-table-column label="操作" width="400" fixed="right">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="primary" @click="editUser(scope.row)">编辑</el-button>
              <el-button v-if="scope.row.type == '0' || scope.row.type == '4' || scope.row.type == '5' || scope.row.type == '6'" icon="el-icon-edit" type="primary" @click="editUserProfile(scope.row)">完善档案</el-button>
              <!-- <el-button icon="el-icon-delete" type="danger" @click="deleteUser(scope.row)" >删除</el-button> -->
              <el-button icon="el-icon-delete" :disabled="scope.row.status == '1'" type="danger" @click="dimission(scope.row)">停职</el-button>
              <el-button icon="el-icon-edit" type="danger" @click="modifyPwd(scope.row)">重置密码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增或编辑弹框 -->
        <el-dialog class="userEdit dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="700px"
          :before-close="done => $handleClose(done, 'editForm', 'doctorForm')" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editForm" :rules="editFormRules" label-width="80px" inline>
            <el-form-item style="position: relative;" label="员工姓名" prop="nickName">
              <div class="nickName-tips">小程序端展示</div>
              <el-input v-model.trim="editForm.nickName" placeholder="请输入员工姓名" />
            </el-form-item>
            <el-form-item label="员工编号" prop="userCode">
              <el-input v-model.trim="editForm.userCode" placeholder="请输入员工编号" />
            </el-form-item><br>
            <el-form-item label="员工密码" prop="password" v-if="dialogTitle == '新增员工'">
              <el-input v-model.trim="editForm.password" placeholder="请输入员工密码" />
            </el-form-item><br>
            <el-form-item label="员工生日" prop="birthday">
              <el-date-picker ref="birthday" v-model="editForm.birthday" type="date" value-format="yyyy-MM-dd"
                placeholder="选择员工生日" :picker-options="{
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                }" />
            </el-form-item>
            <el-form-item label="电话号码" prop="phonenumber">
              <el-input v-model.trim="editForm.phonenumber" placeholder="请输入电话号码" />
            </el-form-item>
            <el-form-item label="员工性别" prop="sex">
              <el-radio-group v-model="editForm.sex">
                <el-radio :label="'0'">男</el-radio>
                <el-radio :label="'1'">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="员工状态" prop="status">
              <el-radio-group v-model="editForm.status" @change="doctorForm.status = editForm.status">
                <el-radio :label="'0'">在职</el-radio>
                <el-radio :label="'1'">离职</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="所属医馆" prop="deptIds">
              <el-select v-model="editForm.deptIds" multiple filterable default-first-option placeholder="请选择医馆">
                <el-option v-for="item in deptsOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="展示医馆" prop="showDeptIds">
              <el-select v-model="editForm.showDeptIds" multiple filterable default-first-option placeholder="请选择医馆">
                <el-option v-for="item in deptsOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="员工角色" prop="roleIds">
              <el-select v-model="editForm.roleIds" multiple filterable default-first-option placeholder="请选择角色">
                <el-option v-for="item in rolesOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="员工类型" prop="type">
              <el-radio-group v-model="editForm.type" @change="typeChange">
                <el-radio v-for="item in typeOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <el-form :model="doctorForm" ref="doctorForm" :rules="doctorFormRules" label-width="110px" inline
            v-if="editForm.type == 0">
            <el-form-item label="医生姓名" style="position: relative;" prop="doctorName">
              <div class="nickName-tips">真实姓名</div>
              <el-input v-model.trim="doctorForm.doctorName" placeholder="请输入医生姓名" />
            </el-form-item>
            <el-form-item label="医生编码" prop="doctorCode">
              <el-input v-model.trim="doctorForm.doctorCode" @input="editForm.doctorCode = doctorForm.doctorCode"
                placeholder="请输入医生编码" />
            </el-form-item>
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model.trim="doctorForm.idCard" placeholder="请输入身份证号" />
            </el-form-item>
            <el-form-item label="公众查询" prop="appStatus">
              <el-radio-group v-model="doctorForm.appStatus">
                <el-radio :label="'0'">可查询</el-radio>
                <el-radio :label="'1'">不可查询</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="医生职称" prop="doctorTitle">
              <el-select v-model="doctorForm.doctorTitle" clearable filterable default-first-option placeholder="请选择医生职称">
                <el-option v-for="item in doctorTitlesOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item label="荣誉称号">
              <el-select v-model="doctorForm.titleIds" clearable filterable multiple default-first-option placeholder="请选择荣誉称号">
                <el-option v-for="item in titlesOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="医生标签">
              <el-select v-model="doctorForm.labelIds" multiple placeholder="请选择医生标签">
                <el-option v-for="item in labelOptions" :key="item.labelId" :label="item.labelName"
                  :value="item.labelId" />
              </el-select>
            </el-form-item>
            <el-form-item label="医生类型" prop="doctorType">
              <el-select v-model="doctorForm.doctorType" multiple placeholder="请选择医生标签" @change="doctorTypeChange">
                <el-option label="医生" :value="1" />
                <el-option label="理疗师" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="坐诊科室">
              <!-- <el-select v-model="doctorForm.postIds" multiple placeholder="请选择坐诊科室">
                <el-option v-for="item in postOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select> -->
              <div class="post_content">
                <el-tooltip effect="dark" :content="doctorForm.doctorPostInfos && doctorForm.doctorPostInfos.map(v => { return v.postName }).join('、')" placement="top">
                  <div class="post_text">{{ doctorForm.doctorPostInfos && doctorForm.doctorPostInfos.map(v => { return v.postName }).join('、') }}</div>
                </el-tooltip>
                <el-button class="post_btn" type="primary" @click="openPostEdit">编辑科室</el-button>
              </div>
            </el-form-item>
            <el-form-item v-if="doctorForm.doctorType && (doctorForm.doctorType.includes(2) || doctorForm.doctorType.includes('2'))" label="是否公共外治" prop="sharePhysio">
              <el-radio-group v-model="doctorForm.sharePhysio">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <br>
            <el-form-item label="医生简介" prop="introduction">
              <el-input type="textarea" v-model="doctorForm.introduction" :autosize="{ minRows: 2, maxRows: 6 }"
                resize="none" />
            </el-form-item>
            <el-form-item label="擅长内容" prop="goodAt">
              <el-input type="textarea" v-model="doctorForm.goodAt" :autosize="{ minRows: 2, maxRows: 6 }"
                resize="none" />
            </el-form-item>
            <el-form-item label="执业照片" prop="doctorImgAddr">
              <div v-if="doctorForm.doctorImgAddr">
                <img :src="doctorForm.doctorImgAddr" class="img" />
                <el-button icon="el-icon-edit" type="primary" @click="editImg" class="btn">修改图片</el-button>
              </div>
              <el-upload v-else :on-success="handleImgSuccess" :action="uploadUrl" list-type="picture-card"
                :data="{ storagePath: 'picture' }" name="files" :before-upload="beforeUpload" :limit="1">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="医生公告">
              <el-input type="textarea" v-model="doctorForm.notice" :autosize="{ minRows: 2, maxRows: 6 }" maxlength="50" resize="none" />
            </el-form-item>
            <el-form-item label="资质" prop="qualifications">
              <el-select v-model="doctorForm.qualifications" multiple collapse-tags placeholder="请选择资质">
                <el-option v-for="item in qualificationList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue" />
              </el-select>
            </el-form-item>
            <!-- <div>
              <el-form-item label="叫号规则" prop="signinPolicy">
                <el-select v-model="doctorForm.signinPolicy">
                  <el-option v-for="item in policyOptions" :key="item.key" :label="item.value" :value="item.key" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="doctorForm.signinPolicy && doctorForm.signinPolicy != 'signin_date'" label="保护位数"
                prop="signinParam" style="width: initial;">
                <el-select v-model="doctorForm.signinParam">
                  <el-option v-for="item in protectionBits" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </div> -->
          </el-form>
          <el-form v-if="editForm.type == 1" ref="assistantForm" :model="assistantForm" label-width="80px" inline>
            <el-form-item label="关联医生" prop="" class="followup">
              <el-select v-model="assistantForm.relationDoctorVos" multiple filterable default-first-option :reserve-keyword="true"
                placeholder="请选择医生助理" value-key="fullId" @visible-change="getFollowupHelpersOptions">
                <el-option v-for="item in followupHelpersOptions" :key="item.fullId" :label="item.fullName"
                  :value="item" />
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button type="success" v-if="dialogTitle == '新增员工'" @click="addSave">保存新增</el-button>
            <el-button type="success" v-if="dialogTitle == '编辑员工'" @click="editSave">保存修改</el-button>
            <el-button @click="$cancel('dialogVisible', 'editForm', 'doctorForm')">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 修改密码弹框 -->
        <el-dialog class="dialogEdit" title="修改员工密码" :visible.sync="pwdVisible" width="330px"
          :before-close="done => $handleClose(done, 'pwdForm')" :close-on-click-modal="false">
          <el-form :model="pwdForm" ref="pwdForm" inline>
            <el-form-item label="新密码" prop="newPwd" :rules="[{ required: true, validator: validatePwd }]">
              <el-input v-model="pwdForm.newPwd" placeholder="请输入新密码" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="pwdSave">保存密码</el-button>
            <el-button @click="$cancel('pwdVisible', 'pwdForm')">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 编辑科室 -->
        <el-dialog
          title="编辑科室"
          :visible.sync="postEditMap.visible"
          width="560px"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :before-close="closePostEdit">
          <div class="postEdit_header">
            <div class="postEdit_btn_list">
              <el-button type="primary" @click="addPost()">增加科室</el-button>
            </div>
          </div>
          <div class="postEdit_table">
            <el-form ref="postEditForm" :model="postEditMap">
              <el-table
                :data="postEditMap.list"
                border
                max-height="300"
                style="width: 100%"
                row-key="vId">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="postId" label="科室名称" min-width="220">
                  <template slot-scope="scope">
                    <el-form-item class="post_form_item" :prop="`list[${scope.$index}].postId`" required :show-message="false">
                      <el-select v-model="scope.row.postId" placeholder="请选择" clearable @change="postSelect(scope.row)">
                        <el-option v-for="item in postOptions" :key="item.value" :label="item.label" :value="item.value" />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="sortNum" label="排序" min-width="120">
                  <template slot-scope="scope">
                    <el-form-item class="post_form_item" :prop="`list[${scope.$index}].sortNum`" required :show-message="false">
                      <el-input v-model="scope.row.sortNum" @input="val => postEditMap.list[scope.$index].sortNum = val.replace(/\D/g, '')" placeholder="请输入" @blur="postSortBlur(scope.row)"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button type="danger" plain @click="delPost(scope.row.vId)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </div>
          <div slot="footer">
            <el-button @click="closePostEdit">取 消</el-button>
            <el-button type="primary" @click="submitPostEdit">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 分页 -->
        <el-pagination @current-change="page => $handleCurrentChange(page, getUsersList)" :total="total"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
      </div>
    </Card>
    <userProfileEdit ref="userProfileEdit"></userProfileEdit>
  </div>
</template>

<script lang="js">
import { userList, userEdit, userAdd, userInfo, pwdModify, userDimission, doctorUnderHospital } from "@/api/user"; // 员工请求
import { roleList } from "@/api/role"; // 角色列表请求
import { titleList } from "@/api/title"; // 称号请求
import { validateName, validatePhone, validatePwd, validateIdCard } from "@/utils/regexp" // 自定义验证
import { uploadTemporaryFile, postList } from "@/api/post"; // 科室请求
import { doctorLabelList } from "@/api/doctorlabel"; // 标签列表请求
import { getAllPolicy } from "@/api/doctor"; // 医生请求
import { isNull, isEmptyArray } from '@/utils/validateBase'
import userProfileEdit from './components/userProfileEdit.vue'

import req from '@/utils/request'

export default {
  name: "User",
  components: { userProfileEdit },
  data() {
    return {
      loading: true, // 加载中
      searchForm: { nickName: null, status: null }, // 查询表单
      userList: [], // 员工列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 基础数据
      doctorForm: {}, // 医生数据
      multipleSelection: [], // 被选中行
      deptsOptions: this.$session.get('options'), // 医馆列表
      rolesOptions: [], // 角色列表
      typeOptions: this.$userType, // 类型列表
      doctorTitlesOptions: this.$doctorTitlesOptions, // 医生职称
      titlesOptions: [], // 荣誉称号
      pwdVisible: false, // 修改密码弹框
      pwdForm: { userId: null, newPwd: null }, // 新密码
      uploadUrl: this.$filePath + '/xl/upload/temp/file/upload', // 图片上传接口地址
      editFormRules: {
        nickName: [{ required: true, message: "请输入员工姓名" }],
        phonenumber: [{ required: true, validator: validatePhone }],
        sex: [{ required: true }],
        status: [{ required: true }],
        userCode: [{ required: true, message: "请输入员工编号" }],
        password: [{ required: true, validator: validatePwd }],
        roleIds: [{ type: 'array', required: true, message: "请选择员工角色" }],
        deptIds: [{ type: 'array', required: true, message: "请选择员工所属医馆" }],
        // birthday: [{ required: true, message: "员工生日不能为空" }],
        type: [{ required: true, message: "请选择员工类型" }]
      }, // 验证规则
      doctorFormRules: {
        doctorName: [{ required: true,  message: "请输入医生真实姓名" }],
        idCard: [{ required: true, validator: validateIdCard, message: "身份证号不能为空！", trigger: "blur" }],
        doctorTitle: [{ required: true, message: "请选择医生职称" }],
        doctorImgAddr: [{ required: true, message: "请上传医生执业照片" }],
        introduction: [{ required: true, message: "医生简介不能为空！" }],
        goodAt: [{ required: true, message: "医生擅长不能为空！" }],
        signinPolicy: [{ required: true, message: "请选择叫号规则" }],
        signinParam: [{ required: true, message: "预约叫号规则不能为空！" }],
        doctorType: [{ required: true, message: "医生类型不能为空！" }],
        sharePhysio: [{ required: true, message: "请选择是否公共外治！" }]
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
      deptId: this.$session.get('deptId'),
      labelOptions: [],
      postOptions: [],
      followupHelpersOptions: [],
      qualificationList: [],
      policyOptions: [],
      protectionBits: [
        // { label: '不保护', value: '0' },
        { label: '保护3位', value: '3' },
        { label: '保护5位', value: '5' },
      ],
      props: { multiple: true },
      assistantForm: {},
      postEditMap: {
        visible: false,
        list: []
      }
    };
  },
  created() {
    if (document.documentElement.clientWidth > 1236) this.tableHeight = document.documentElement.clientHeight - 330;
    else this.tableHeight = document.documentElement.clientHeight - 370;
    this.getUsersList(); // 请求员工列表
    // this.getUsersListAssistant();//获取医助列表
    this.getRolesData(); // 请求角色列表
    this.getTitlesData(); // 请求称号列表
    this.getDoctorLabelList();
    this.getPostList(); // 请求科室列表
    this.getAllPolicy()
    this.getQualificationList()
    this.validatePwd = validatePwd;
  },
  methods: {
    // 请求所有员工列表
    async getUsersList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await userList(params);
      if (code == 200) {
        if (total > 0) {
          rows.forEach(item => {
            switch (item.type) {
              case "0": item.typeStr = "医生"; break;
              case "1": item.typeStr = "医助"; break;
              case "2": item.typeStr = "员工"; break;
              case "3": item.typeStr = "其他"; break;
              case "4": item.typeStr = "理疗师"; break;
              case "5": item.typeStr = "药师"; break;
              case "6": item.typeStr = "护士"; break;
            }
          });
        }
        this.total = total;
        this.userList = rows;
      }
      this.loading = false;
    },
    // 请求角色列表
    async getRolesData() {
      let { code, rows, total } = await roleList();
      if (code == 200 && total > 0) rows.forEach(item => { this.rolesOptions.push({ label: item.roleName, value: item.roleId }) });
    },
    // 请求称号列表
    async getTitlesData() {
      let { code, rows, total } = await titleList();
      if (code == 200 && total > 0) rows.forEach(item => { this.titlesOptions.push({ label: item.titleName, value: item.titleId }) });
    },
    // 新增员工
    addUser() {
      this.dialogVisible = true;
      this.dialogTitle = "新增员工";
      this.editForm = { nickName: null, password: null, sex: '0', phonenumber: null, deptIds: [], showDeptIds: [], status: '0', roleIds: [], type: '3', deptId: this.deptId };
      this.doctorForm = {
        doctorName: null, idCard: null, doctorTitle: null, doctorImgAddr: null, titleIds: [], appStatus: '0',notice:null,
        status: '0', assistantName: null, introduction: null, goodAt: null, labelIds: [], signinPolicy: null, signinParam: null,doctorType:[],sharePhysio:0,qualifications:[]
      };
      this.assistantForm = {
        relationDoctorVos: []
      }
    },
    // 保存新增
    addSave() {
      let formArr, resultArr = [], _this = this;
      if (this.editForm.type == 0) {
        formArr = ['editForm', 'doctorForm'];
      } else if (this.editForm.type == 1) {
        formArr = ['editForm', 'assistantForm'];
      } else {
        formArr = ['editForm'];
      }
      function checkForm(formName) {
        let result = new Promise(function (resolve, reject) {
          _this.$refs[formName].validate((valid) => {
            if (valid) resolve();
            else reject();
          })
        })
        resultArr.push(result)
      }
      formArr.forEach(item => { checkForm(item) });
      Promise.all(resultArr).then(function () {
        userAdd(_this.handle()).then(res => {
          let { code } = res;
          if (code == 200) {
            _this.$message.success("新增员工成功！");
            _this.$refresh(_this.getUsersList);
            _this.dialogVisible = false;
            formArr.forEach(item => { _this.$refs[item].resetFields() })
          }
        })
      }).catch(function () {
        console.log("err");
      });
    },
    // 员工停职
    dimission(row) {
      let msg1 = '', msg2 = '';
      if (row.hospDoctorInfo) {
        msg1 = '，该员工所有排班将停诊！';
        msg2 = '排班已停诊、';
      }
      row.status = '1';
      this.$confirm(`确认停职该员工？停职后将不能登录系统${msg1}`).then(_ => {
        userDimission(row).then(res => {
          if (res.code == 200) {
            this.$message.success(`该员工停职成功，${msg2}系统账号已不能登录！`);
            this.$refresh(this.getUsersList);
          }
        })
      }).catch(_ => { });
    },
    // 编辑员工信息
    async editUser(row) {
      let { data, code } = await userInfo(row.userId);
      if (code == 200) {
        this.editForm = JSON.parse(JSON.stringify(data.data)); // 给表单赋值
        this.editForm.roleIds = data.roleIds;
        this.editForm.deptIds = data.deptIds;
        this.editForm.showDeptIds = data.showDeptIds;
        this.editForm.deptId = this.deptId;
        // 判断员工是否是医生
        if (this.editForm.type == 0) {
          this.doctorForm = this.editForm.hospDoctorInfo;
          delete this.doctorForm.dailyHelpers
          delete this.doctorForm.helperIds
          delete this.doctorForm.helpers
        } else if (this.editForm.type == 1) {
          this.assistantForm = this.editForm.assistantDoctorVo || {};
          await this.getFollowupHelpersOptions(true)
        } else {
          this.doctorForm = {}
        }
        this.dialogTitle = "编辑员工";
        this.dialogVisible = true;
      }
    },
    // 保存员工修改
    editSave() {
      let formArr, resultArr = [], _this = this;
      if (this.editForm.type == 0) {
        formArr = ['editForm', 'doctorForm'];
      } else if (this.editForm.type == 1) {
        formArr = ['editForm', 'assistantForm'];
      } else {
        formArr = ['editForm'];
      }
      function checkForm(formName) {
        let result = new Promise(function (resolve, reject) {
          _this.$refs[formName].validate((valid) => {
            if (valid) resolve();
            else reject();
          })
        })
        resultArr.push(result)
      }
      formArr.forEach(item => { checkForm(item) })
      Promise.all(resultArr).then(function () {
        userEdit(_this.handle()).then(res => {
          let { code } = res;
          if (code == 200) {
            _this.$message.success("员工信息修改成功！");
            _this.$refresh(_this.getUsersList);
            _this.dialogVisible = false;
            formArr.forEach(item => { _this.$refs[item].resetFields() });
          }
        })
      }).catch(function () {
        console.log("err");
      });
    },
    editUserProfile (row) {
      this.$refs.userProfileEdit.open({ userId: row.userId, name: row.nickName, type: row.type  })
    },
    // 处理参数
    handle() {
      let params = JSON.parse(JSON.stringify(this.editForm));
      if (params.type == 0) params.hospDoctorInfo = this.doctorForm;
      if (params.type == 1) params.assistantDoctorVo = this.assistantForm;
      return params;
    },
    // 修改密码
    modifyPwd(row) {
      this.pwdVisible = true;
      this.pwdForm = { userId: row.userId, newPwd: null }
    },
    // 保存密码修改
    pwdSave() {
      this.$refs["pwdForm"].validate((valid) => {
        if (valid) {
          pwdModify({ userId: this.pwdForm.userId, password: this.pwdForm.newPwd }).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("修改密码成功！");
            this.pwdVisible = false;
            this.$refs["pwdForm"].resetFields();
          })
        } else return false;
      });
    },
    /**
     * 上传前
    */
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
    },
    // 图片上传成功的函数
    async handleImgSuccess(res, file,) {
      if (res.errorCode == "0000") {
        let arr = []
        arr[0] = { uploadChannel: "postImg", fileId: res.data[0].fileId, groupName: "group1", isNeedThumbnail: "2" }
        let uploadRes = await uploadTemporaryFile(arr)
        if (uploadRes.errorCode == '0000') {
          this.doctorForm.doctorImgAddr = uploadRes.data[0].fullPathUrl;
        }
      }
      // let { code, msg } = res;
      // if (code === 200) this.doctorForm.doctorImgAddr = msg;
    },
    // 清除图片地址，显示上传图片
    editImg() {
      this.doctorForm.doctorImgAddr = null;
    },
    // 获取标签列表
    async getDoctorLabelList() {
      let { total, rows, code } = await doctorLabelList({ type: 0 });
      if (total > 0 && code == 200) rows.forEach(item => { this.labelOptions.push({ labelName: item.name, labelId: item.doctorLabelId }) });
    },
    // 获取科室列表
    async getPostList() {
      let { total, rows, code } = await postList();
      if (total > 0 && code == 200) rows.forEach(item => { this.postOptions.push({ label: item.postName, value: item.postId }) });
    },
    async getAllPolicy() {
      let { code, data } = await getAllPolicy()
      if (code == 200) {
        this.policyOptions = data
      }
    },
    async getQualificationList () {
      const res = await req.get('/system/dict/data/type/DOCTOR_QUALIFICATIONS')
      if (res.code == 200) {
        this.qualificationList = res.data
      }
    },
    // 查询当前医助理，所属医馆下的医生
    async getFollowupHelpersOptions(event) {
      this.followupHelpersOptions = []
      if (event) {
        let currentDeptId = this.$session.get('deptId')
        let deptIds = []
        if (currentDeptId == '0' || currentDeptId == '-1') {
          // 总部
          if (isNull(this.editForm.deptIds) || isEmptyArray(this.editForm.deptIds)) {
            return this.$message.error('请先选择所属医馆！')
          }
          deptIds = this.editForm.deptIds
        }else{
          deptIds[0] = currentDeptId
        }
        let { code, data } = await doctorUnderHospital({ deptIds })
        if (code == 200) {
          this.followupHelpersOptions = data
        }
      }
    },
    typeChange(val) {
      if (val == '0') {
        this.doctorForm = {
          doctorName: this.editForm.nickName, idCard: null, doctorTitle: null, doctorImgAddr: null, titleIds: [], appStatus: '0',notice:null,
          status: '0', assistantName: null, introduction: null, goodAt: null, labelIds: [], signinPolicy: null, signinParam: null,doctorType:[],sharePhysio:0,qualifications:[]
        };
      } else if (val == '1') {
        this.assistantForm = {
          relationDoctorVos: []
        }
      }
    },
    generateUUID () {
      return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    doctorTypeChange (values) {
      if (values.includes(2) || values.includes('2')) {
        this.doctorForm.sharePhysio = 1;
      } else {
        this.doctorForm.sharePhysio = 0;
      }
    },
    openPostEdit () {
      this.postEditMap.visible = true
      const list = (this.doctorForm.doctorPostInfos && JSON.parse(JSON.stringify(this.doctorForm.doctorPostInfos))) || []
      this.postEditMap.list = list.map(v => {
        const post = this.postOptions.find(p => p.value === v.postId)
        v['vId'] = this.generateUUID()
        v['postName'] = post ? post.label : ''
        return v
      })
    },
    closePostEdit () {
      this.postEditMap.visible = false
      this.postEditMap.list = []
    },
    addPost () {
      this.postEditMap.list.unshift({
        vId: this.generateUUID(),
        postId: '',
        postName: '',
        sortNum: ''
      })
    },
    delPost (vId) {
      this.$confirm('确认删除该科室?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.postEditMap.list.findIndex(v => v.vId === vId)
        if (index > -1) {
          this.postEditMap.list.splice(index, 1)
        }
      }).catch(() => {})
    },
    postSelect (row) {
      const has = this.postEditMap.list.some(v => v.vId !== row.vId && v.postId === row.postId)
      if (has) {
        this.$message.error('此科室已存在')
        row.postId = ''
        row.postName = ''
      } else {
        const post = this.postOptions.find(v => v.value === row.postId)
        if (post) {
          row.postName = post.label
        }
      }
    },
    postSortBlur (row) {
      let list = JSON.parse(JSON.stringify(this.postEditMap.list))
      list.sort((a, b) => {
        return Number(a.sortNum) - Number(b.sortNum)
      })
      this.postEditMap.list = list
      
      this.$nextTick(() => {
        const newIndex = this.postEditMap.list.findIndex(v => v.vId === row.vId)
        this.$refs['postEditForm'].validateField(`list[${newIndex}].sortNum`)
      })
    },
    submitPostEdit () {
      this.$refs['postEditForm'].validate(valid => {
        if (valid) {
          this.doctorForm.doctorPostInfos = JSON.parse(JSON.stringify(this.postEditMap.list))
          this.closePostEdit()
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  .userEdit {
    .el-form-item:not(:last-child) {
      width: 50%;
      margin-right: 0;
    }
  }

  .img {
    width: 200px;
    height: auto;
    display: block;
  }

  .btn {
    margin-top: 5px;
  }

  .followup {
    width: 50%;
    background: #F7F8F9;
    padding-right: 10px;
    box-sizing: border-box;
  }
}

.post_content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 220px;
}

.post_text {
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.post_btn {
  margin: 0 0 0 10px;
}

.postEdit_table{
  margin: 10px 0 0 0;
}

.post_form_item {
  margin: 0 0 0 0;
}
.nickName-tips{
  position: absolute;
  top: -26px;
  left: 0px;
  color: red;
}
</style>